import { format } from "date-fns";
import { Controller } from "react-hook-form";
import { DateTimePicker } from "@onengine/component-library";
import { toValidDate } from "@/utils/dateFormatter";
import { FormErrorBox } from "@/components/ui/FormErrorBox/FormErrorBox";
import type { ControlledFieldProps } from "./types";

const TIME_FORMAT = "hh:mm aa";

export function ControlledDateTimePicker({
  name,
  control,
  error,
  clearErrors,
}: ControlledFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => {
        const currentDate = toValidDate(field.value);

        return (
          <>
            <DateTimePicker
              dateValue={currentDate}
              timeValue={currentDate ? format(currentDate, TIME_FORMAT) : undefined}
              onChange={(dateTime) => {
                field.onChange(dateTime);
                clearErrors(name);
              }}
              error={!!error}
              clearable
            />
            {error && <FormErrorBox message={error} mt="6" />}
          </>
        );
      }}
    />
  );
}
